













import { Component, Prop, Vue, Inject } from "vue-property-decorator";

// Types
import { IClient } from "@/models/clients";
import { IClientProviderData } from "@/models/providers/client";

@Component({
  components: {
    "cprod-prov-requests-table": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvRequestsTable.vue"
      )
  }
})
export default class AdminClientProvisionRequestLogs extends Vue {
  // Inject

  @Inject("clientProvider")
  public readonly $clientProvider!: () => IClientProviderData;

  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  // Computed

  public get $clientData() {
    return this.$clientProvider();
  }
}
